import { ValueOf } from "./utility";

export enum ZendeskTags {
  creationSourceRequestCallback = "sg_hc_callback",
  creationSourceSupportRequest = "sg_hc_supportForm",
  creationSourceDoNotActivate = "sg_hc_account_access_issue",
  creationSourceUauthorizedAccess = "sg_hc_unauthorized",
  creationSourceOneSupportCenterUngated = "osc_ungated",
  creationSourceOneSupportCenterGated = "osc_gated",
  creationSourceOscWiseOwlGated = "hca_gated",
  creationSourceOscWiseOwlUngated = "hca_ungated",
  ingressSourceOscWiseOwlNegativeFeedback = "hca_negative_feedback",
  directLiveChatCreation = "direct_live_chat",
  questionsAskedInChat = "hca_ci_chat_questions",
  questionsRelevant = "hca_ci_form_relevant",
  questionsNotRelevant = "hca_ci_form_not_relevant",
}

export interface ZendeskAttachment {
  name: string;
  url: string;
  type: string;
}

export interface ZendeskField {
  name: string;
  value: string;
  default?: boolean;
}

export const ZendeskTicketStatusEnum = {
  new: "new",
  open: "open",
  pending: "pending",
  hold: "hold",
  solved: "solved",
  closed: "closed",
} as const;
export type ZendeskTicketStatusEnumType = ValueOf<
  typeof ZendeskTicketStatusEnum
>;
